import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { fetchGet } from '../reduxactions/suprivisoractions/SupDocReportsActions';
import { useLocation, useParams } from 'react-router-dom';
import { Doctornames, fetchDocData1, fetchDocData2, fetchDocData3, fetchDocData4, HospitalNames, ViewImageData } from '../reduxactions/medicalofficeractions/MOApprovedActions';

import { RootState } from '../reducers';
import { Card } from 'primereact/card';
import { Panel } from 'primereact/panel';
//for document add
import { UploadImageData } from '../reduxactions/suprivisoractions/SupApproveActions';

import useEffectOnce from '../hooks/useEffectOnce';
import { Stepper } from 'primereact/stepper';
import { StepperPanel } from 'primereact/stepperpanel';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Splitter, SplitterPanel } from 'primereact/splitter';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import { FileUpload, FileUploadHandlerEvent } from 'primereact/fileupload';
import { MEOFFICER_API, SUPRIVISOR_API } from '../ApiNames';
import { LoginService } from '../services/LoginService';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import { MHeader } from '../Header/MHeader';
import { Toast } from 'primereact/toast';
var imageuser = require('../assets/img/userim.png');
export const MedicalApprovedApplication = () => {
    const uid = window.sessionStorage.getItem('uid');

    const [globalFilter, setGlobalFilter] = useState('');
    const stepperRef = useRef(null);

    const [activeIndex, setActiveIndex] = useState(0);

    const location = useLocation();
    const dispatch = useDispatch();

    const [queryParams, setQueryParams] = useState(null);
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        setQueryParams(params.get("id") as any);
    }, [location]);
    const { id } = useParams();
    const getdata1 = useSelector((state: RootState) => state.mapprovedview.getdetails1);
    const getdata2 = useSelector((state: RootState) => state.mapprovedview.getdetails2);
    const getdata3 = useSelector((state: RootState) => state.mapprovedview.getdetails3);
    const getdata4 = useSelector((state: RootState) => state.mapprovedview.getdetails4);
        const [fileName, setFileName] = useState('');
    
    const statusData = getdata1[0]?.status;
    const hospitalnames = getdata1[0]?.hospitalname;
    const dname = getdata1[0]?.dname;
    const Did = getdata1[0]?.Did;
    const hid = getdata1[0]?.hospitalid;

    //To get data
    const fetchDataAsync = async () => {
        try {
            await dispatch(fetchGet(uid) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchDataAsync1 = async () => {
        try {
            await dispatch(fetchDocData1(id, uid) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    //To get data
    const fetchDataAsync2 = async () => {
        try {
            await dispatch(fetchDocData2(id, uid) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchDataAsync3 = async () => {
        try {
            await dispatch(fetchDocData3(id, uid) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    //To get data
    const fetchDataAsync4 = async () => {
        try {
            await dispatch(fetchDocData4(id, uid) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const [message, setMessage] = useState('');
    const sendMessege = async () => {
        try {
            const payload = { aid: id, message: message, userid: uid, q: 12 };
            const apiname = MEOFFICER_API.mapplications;
            const response = await LoginService.getData(apiname, payload);
            fetchDataAsync2();
            setMessage('');
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffectOnce(() => {
        fetchDataAsync();
        fetchDataAsync1();
        fetchDataAsync2();
        fetchDataAsync3();
        fetchDataAsync4();
    }, [dispatch]);
    const [Adddocument, setAdddocument] = useState(false);
    const [doc_name, setDocument] = useState<string>('');
    const close = () => {
        setAdddocument(false);
        setfield(false);
    }
    const images = useSelector((state: RootState) => state.sviewapprovedapplication.image);

    const UploadManagerImage = async (event: FileUploadHandlerEvent) => {
        const files = event.files;
        if (files.length > 0) {
            const file = files[0];
            console.log("file:", file)
            console.log("called image function:", file)
            try {
                await dispatch(UploadImageData(file, uid) as any);
            } catch (error) {
                console.error('Error uploading image:', error);
            }
        }

    };
    const addDataAsync = async () => {
        try {
            const payload = { aid: id, doctitle: doc_name, filename: images.filename, userid: uid, q: 8 };
            const apiname = SUPRIVISOR_API.sviewapprovedapplications;
            const response = await LoginService.getData(apiname, payload);
            fetchDataAsync4();
            setAdddocument(false);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const [acceptfield, setfield] = useState(false);
    const view = useSelector((state: RootState) => state.sviewapprovedapplication.view);

    const viewupload = (rowData: any) => {
        assignData.current = { DocID: rowData.DocID }

        setfield(true);
        fetchDataAsyncdialog()
    };
    const assignData = useRef({ DocID: '' })

    const fetchDataAsyncdialog = async () => {
        try {
            const { DocID } = assignData.current;
            console.log("DocID", DocID)
            await dispatch(ViewImageData(DocID) as any);
        } catch (error) {
            console.error('Error deleting data:', error);
        }
    }
    const hospitalValues = useSelector((state: RootState) => state.mapprovedview.hname);
    const doctorvalues = useSelector((state: RootState) => state.mapprovedview.dname);
    const [verifyDilog, setVerifyDilog] = useState(false);
    const [hospitalname, sethospitalName] = useState('');
    const [doctorname, setDocName] = useState('');
    const [Amount, setEAmount] = useState('');
    const [Date, setDate] = useState('');
    const fetchHospitalNamess = async () => {
        try {
            const response = await dispatch(HospitalNames(id) as any);
            setDocName(response.hospitalID)
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchDoctorNamesss = async (hospitalID: any) => {
        try {
            await dispatch(Doctornames(hospitalID) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const toast2 = useRef<Toast>(null)
    useEffectOnce(() => {
        fetchHospitalNamess();
    }, [dispatch]);
    const VerifyApplication = async () => {
        try {
            const payload = { aid: id, doctorid: Did, hospitalid: hid, userid: uid, estimation_amount: Amount, expirey_date: Date, q: 7 };
            const apiname = MEOFFICER_API.mapplications;
            const response = await LoginService.getData(apiname, payload);
            if (toast2.current) {
                toast2.current.show({ severity: 'success', detail: response });
            }
            setVerifyDilog(false);
            fetchDataAsync1();
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const [holddilog, setholddilog] = useState(false);
    const [hreason, setHreason] = useState('');
    const HoldApplication = async () => {
        try {
            const payload = { aid: id, reason: hreason, q: 6 };
            const apiname = MEOFFICER_API.mapplications;
            const response = await LoginService.getData(apiname, payload);
            if (toast2.current) {
                toast2.current.show({ severity: 'success', detail: response });
            }
            setholddilog(false);
            fetchDataAsync1();
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const [reject, setReject] = useState(false);
    const [rreason, setRreason] = useState('');
    const RejectApplication = async () => {
        try {
            const payload = { aid: id, reason: rreason, q: 5 };
            const apiname = MEOFFICER_API.mapplications;
            const response = await LoginService.getData(apiname, payload);
            if (toast2.current) {
                toast2.current.show({ severity: 'success', detail: response });
            }
            setReject(false);
            fetchDataAsync1();
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/medioffi-viewallapplications.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };
    return (
        <>
            <MHeader />
            <div className="admin-layout-container">
                <div className="row">
                    <div className="main-content">
                        <div className="col-16" style={{ textAlign: "right" }}>
                            <a
                                title="help"
                                onClick={(e) => openWindow(e, IUrl)}
                                style={{

                                    color: "blue",
                                    fontSize: 15, cursor: "pointer"
                                }}
                            >Help for this Page &nbsp;
                                <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                            </a>
                        </div>



                        <div className="content-wrapper">
                            <section className="content">
                                <div className="grid" style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <div className="col-left" style={{ display: 'flex', flexDirection: 'column', width: '25%' }}>
                                        {getdata1.map((response: any) => (
                                            <div className="col-12" style={{ marginBottom: '20px' }}>
                                                <Panel header="" style={{ width: '100%' }}>
                                                    {/* Header with photo and name */}
                                                    <div className="widget-user-header bg-info"
                                                        style={{
                                                            height: '100px',
                                                            backgroundColor: 'rgb(255, 193, 7)',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            width: '100%'
                                                        }}
                                                    >
                                                        <img
                                                            src={response.photo}
                                                            alt="User Avatar"
                                                            style={{
                                                                width: '100px',
                                                                height: '60px',
                                                                borderRadius: '50%',
                                                                marginRight: '15px'
                                                            }}
                                                        />
                                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                            <h2 style={{ color: 'black', fontWeight: '200', fontSize: '25px', marginBottom: '10px' }}>
                                                                {response.pfname}
                                                            </h2>
                                                            <h3 style={{ color: 'black', fontSize: '1.25rem', margin: '0', fontWeight: '400' }}>
                                                                Patient
                                                            </h3>
                                                        </div>
                                                    </div>

                                                    {/* Info rows */}
                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '8px 0' }}>
                                                        <strong>E-Mail</strong>
                                                        <p style={{
                                                            backgroundColor: 'rgb(0, 123, 255)',
                                                            color: 'white',
                                                            borderRadius: '6px',
                                                            fontSize: '0.85rem',
                                                            margin: 0,
                                                            padding: '4px 10px',
                                                            maxWidth: '60%',
                                                            textAlign: 'right'
                                                        }}>
                                                            {response.pemail}
                                                        </p>
                                                    </div>
                                                    <hr style={{ height: '1px', border: 'none', backgroundColor: '#dee2e6', margin: '10px 0' }} />

                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '8px 0' }}>
                                                        <strong>Phone</strong>
                                                        <p style={{
                                                            backgroundColor: 'rgb(23, 162, 184)',
                                                            color: 'white',
                                                            borderRadius: '6px',
                                                            fontSize: '0.85rem',
                                                            margin: 0,
                                                            padding: '4px 10px',
                                                            maxWidth: '60%',
                                                            textAlign: 'right'
                                                        }}>
                                                            {response.pmobile}
                                                        </p>
                                                    </div>
                                                    <hr style={{ height: '1px', border: 'none', backgroundColor: '#dee2e6', margin: '10px 0' }} />

                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '8px 0' }}>
                                                        <strong>City</strong>
                                                        <p style={{
                                                            backgroundColor: 'rgb(40, 167, 69)',
                                                            color: 'white',
                                                            borderRadius: '6px',
                                                            fontSize: '0.85rem',
                                                            margin: 0,
                                                            padding: '4px 10px',
                                                            maxWidth: '60%',
                                                            textAlign: 'right'
                                                        }}>
                                                            {response.pcity}
                                                        </p>
                                                    </div>
                                                    <hr style={{ height: '1px', border: 'none', backgroundColor: '#dee2e6', margin: '10px 0' }} />

                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '8px 0' }}>
                                                        <strong>State</strong>
                                                        <p style={{
                                                            backgroundColor: 'rgb(220, 53, 69)',
                                                            color: 'white',
                                                            borderRadius: '6px',
                                                            fontSize: '0.85rem',
                                                            margin: 0,
                                                            padding: '4px 10px',
                                                            maxWidth: '60%',
                                                            textAlign: 'right'
                                                        }}>
                                                            {response.pstate}
                                                        </p>
                                                    </div>
                                                    <hr style={{ height: '1px', border: 'none', backgroundColor: '#dee2e6', margin: '10px 0' }} />

                                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', margin: '8px 0' }}>
                                                        <strong>Country</strong>
                                                        <p style={{
                                                            backgroundColor: 'rgb(220, 53, 69)',
                                                            color: 'white',
                                                            borderRadius: '6px',
                                                            fontSize: '0.85rem',
                                                            margin: 0,
                                                            padding: '4px 10px',
                                                            maxWidth: '60%',
                                                            textAlign: 'right'
                                                        }}>
                                                            {response.CountryName}
                                                        </p>
                                                    </div>
                                                </Panel>
                                                {/* Doctor Panel */}
                                                <Panel header="" style={{ width: '100%', marginTop: '20px' }}>
                                                    {/* Header with hospital name and image */}
                                                    <div className="widget-user-header bg-info" style={{
                                                        height: '100px',
                                                        backgroundColor: 'rgb(255, 193, 7)',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        width: '100%'
                                                    }}>
                                                        <img
                                                            src={response.hosp_photo}
                                                            alt="User Avatar"
                                                            style={{
                                                                width: '100px',
                                                                height: '60px',
                                                                borderRadius: '50%',
                                                                marginRight: '15px'
                                                            }}
                                                        />
                                                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                            <h2 style={{
                                                                color: 'black',
                                                                fontWeight: '200',
                                                                fontSize: '20px', // smaller font
                                                                marginBottom: '5px'
                                                            }}>
                                                                {response.hospitalname}
                                                            </h2>
                                                            <h3 style={{
                                                                color: 'black',
                                                                fontSize: '14px', // smaller font
                                                                margin: '0',
                                                                fontWeight: '400'
                                                            }}>
                                                                Medical
                                                            </h3>
                                                        </div>
                                                    </div>

                                                    {/* Email Row */}
                                                    <div style={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center',
                                                        whiteSpace: 'nowrap',
                                                        marginTop: '20px',
                                                        marginBottom: '5px'
                                                    }}>
                                                        <strong style={{ flex: '0 0 auto', fontSize: '14px' }}>E-Mail</strong>
                                                        <p style={{
                                                            backgroundColor: 'rgb(0, 123, 255)',
                                                            color: 'white',
                                                            borderRadius: '6px',
                                                            padding: '5px 10px',
                                                            marginBottom: '0',
                                                            marginLeft: '10px',
                                                            fontSize: '13px'
                                                        }}>
                                                            {response.email}
                                                        </p>
                                                    </div>
                                                    <hr style={{ height: '1px', border: 'none', backgroundColor: '#dee2e6', margin: '10px 0' }} />

                                                    {/* Phone Row */}
                                                    <div style={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center',
                                                        whiteSpace: 'nowrap',
                                                        marginBottom: '5px'
                                                    }}>
                                                        <strong style={{ flex: '0 0 auto', fontSize: '14px' }}>Phone</strong>
                                                        <p style={{
                                                            backgroundColor: 'rgb(23, 162, 184)',
                                                            color: 'white',
                                                            borderRadius: '6px',
                                                            padding: '5px 10px',
                                                            marginBottom: '0',
                                                            marginLeft: '10px',
                                                            fontSize: '13px'
                                                        }}>
                                                            {response.phone}
                                                        </p>
                                                    </div>
                                                    <hr style={{ height: '1px', border: 'none', backgroundColor: '#dee2e6', margin: '10px 0' }} />

                                                    {/* City Row */}
                                                    <div style={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center',
                                                        whiteSpace: 'nowrap',
                                                        marginBottom: '5px'
                                                    }}>
                                                        <strong style={{ flex: '0 0 auto', fontSize: '14px' }}>City</strong>
                                                        <p style={{
                                                            backgroundColor: 'rgb(40, 167, 69)',
                                                            color: 'white',
                                                            borderRadius: '6px',
                                                            padding: '5px 10px',
                                                            marginBottom: '0',
                                                            marginLeft: '10px',
                                                            fontSize: '13px'
                                                        }}>
                                                            {response.city}
                                                        </p>
                                                    </div>
                                                </Panel>



                                            </div>
                                        ))}
                                    </div>

                                    <div className="col-right" style={{ width: '70%', marginRight: '50px' }}>
                                        {getdata1.map((response: any) => (
                                            <Panel header="Application Details" style={{ minHeight: '500px', width: '100%', padding: '20px' }} key={response.application_ID}>
                                                <div className="grid">
                                                    <div className="col-12 md:col-12 lg:col-6">
                                                        {[
                                                            { label: 'Application ID', value: response.application_ID },
                                                            { label: 'Application Type', value: response.type },
                                                            { label: 'Patient Name', value: response.pfname },
                                                            { label: 'Email ', value: response.pemail },
                                                            { label: 'Phone No', value: response.pmobile },
                                                            { label: 'Identity Proof', value: response.proof_type },
                                                            { label: 'Type Identity', value: response.proof_ID },
                                                            { label: 'Card Number', value: response.health_card_number },
                                                            { label: 'City', value: response.pcity },
                                                            { label: 'State', value: response.pstate },
                                                            { label: 'Country', value: response.CountryName },
                                                        ].map(({ label, value }) => (
                                                            <div className='grid' style={{ display: 'flex', alignItems: 'center', marginBottom: '40px' }} key={label}>
                                                                <strong style={{ marginRight: '20px', flex: '1' }}>{label} :</strong>
                                                                <p className="text-muted" style={{ flex: '2', margin: 0 }}>{value}</p>
                                                            </div>
                                                        ))}
                                                    </div>
                                                    <div className="col-12 md:col-12 lg:col-6">
                                                        {[
                                                            { label: 'Card No', value: response.health_card_number },
                                                            { label: 'Sickness', value: response.Sickness },
                                                            { label: 'Description', value: response.sickness_description },
                                                            { label: 'Preferred Doctor', value: response.dname },
                                                            { label: 'Preferred Hospital', value: response.hospitalname },
                                                            // { label: 'Preferred City', value: response.prefered_city },
                                                            { label: 'Preferred State', value: response.prefered_state },
                                                            { label: 'Preferred Country', value: response.prefered_country },
                                                            { label: 'Status', value: response.status },
                                                            { label: 'Preferred Region', value: response.regionname },
                                                        ].map(({ label, value }) => (
                                                            <div className='grid' style={{ display: 'flex', alignItems: 'center', marginBottom: '40px' }} key={label}>
                                                                <strong style={{ marginRight: '20px', flex: '1' }}>{label} :</strong>
                                                                <p className="text-muted" style={{ flex: '2', margin: 0 }}>{value}</p>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            </Panel>
                                        ))}


                                        <Panel header="Chat" style={{ marginTop: '20px' }}>
                                            {getdata2.map((item: any, index: any) => (
                                                <div key={item.id || index} style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                                                    <img
                                                        className="direct-chat-img"
                                                        src={item.photo === "https://apps.dinkhoo.com/uploads/content/e_medicall/profile/" ? imageuser : item.photo}
                                                        alt="User Avatar"
                                                        style={{ width: '50px', height: '50px', borderRadius: '50%', marginRight: '15px', border: '0.4px solid rgba(0, 0, 0, 0.125)' }}
                                                    />
                                                    <div>
                                                        <span style={{ marginLeft: '-10px' }}>{item.name}</span>
                                                        <span style={{ color: 'gray', marginLeft: '6px' }}>{item.date}</span>
                                                    </div>
                                                    <p style={{ marginLeft: '35px' }}>{item.msg}</p>
                                                </div>
                                            ))}
                                            <div>
                                                <div className="grid">
                                                    <div className='col-11'>
                                                        <InputText value={message} placeholder="Type Message ..." className="w-full mb-10" onChange={(e) => setMessage(e.target.value)} />
                                                    </div>
                                                    <span className="input-group-btn">
                                                        <div className='col-1'>
                                                            <Button severity="info" icon="pi pi-send" rounded outlined onClick={sendMessege} style={{ color: 'green' }} />
                                                        </div>
                                                    </span>
                                                </div>
                                            </div>
                                        </Panel>
                                        <Panel header="Document Upload" style={{ marginTop: '20px' }}>
                                            <div className="card flex flex-wrap justify-content-end">
                                                <Button label="Upload Docs" severity="info" onClick={() => setAdddocument(true)} />
                                            </div>
                                            <DataTable value={getdata4} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter}>
                                                <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                                <Column field="doc_name" sortable header="Document Title"></Column>
                                                <Column header="Option" body={(rowData) => (
                                                    <div className="options-buttons">
                                                        <Button icon="pi pi-eye" rounded outlined tooltip="View" className="p-button-danger mr-1" style={{ backgroundColor: 'white', color: 'blue', width: '2rem', height: '2rem' }} onClick={() => viewupload(rowData)} />
                                                    </div>

                                                )}></Column>
                                            </DataTable>
                                        </Panel>
                                        <div className='grid'>
                                            <div className='col-8'></div>
                                            <div className='col-4' style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '10px' }}>
                                                {getdata1[0]?.status !== 'VERIFIED' && (
                                                    <Button severity="success" label="Verify" rounded style={{ paddingRight: '64px' }} onClick={() => setVerifyDilog(true)} />
                                                )}
                                                {getdata1[0]?.status !== 'HOLD' && (
                                                    <Button severity="warning" label="Hold" rounded style={{ paddingRight: '56px' }} onClick={() => setholddilog(true)} />
                                                )}
                                                {getdata1[0]?.status !== 'REJECTED' && (
                                                    <Button severity="danger" label="Reject" rounded style={{ paddingRight: '64px' }} onClick={() => setReject(true)} />
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <Dialog header="Upload Document" visible={Adddocument} style={{ width: '30vw', height: '40' }} onHide={() => setAdddocument(false)} >
                                        <div className='row'>
                                            <div className='row'>
                                                <div className="grid pt-3">
                                                    <div className="col-3">
                                                        <label htmlFor="name"   >Document Title:</label>
                                                    </div>
                                                    <div className="col md-3" >
                                                        <InputText id="name" style={{ width: '15vw' }} name="document" placeholder='Document-title' onChange={(e) => setDocument(e.target.value)} />
                                                    </div>
                                                    <div className="col-2" ></div>
                                                </div>
                                            </div>
                                            {/* <div className='row'>
                                                <div className="grid pt-3">
                                                    <div className="col-3">
                                                        <label htmlFor="file" >Select File:</label>
                                                    </div>
                                                    <div className="col-3" >
                                                        <FileUpload mode="basic" id="fileToUpload" name="fileToUpload" customUpload accept="image/*" maxFileSize={1000000} uploadHandler={UploadManagerImage} auto />
                                                    </div>
                                                </div>
                                            </div> */}
                                            <div className='row'>
                                                                          <div className="grid pt-3">
                                                                            
                                                                            <div className="col-3">
                                                                              <label htmlFor="file">Select File:</label>
                                                                            </div>
                                                                        
                                                                            <div className="col-3">
                                                                              <FileUpload
                                                                                mode="basic"
                                                                                id="fileToUpload"
                                                                                name="fileToUpload"
                                                                                customUpload
                                                                                accept="image/*"
                                                                                maxFileSize={1000000}
                                                                                uploadHandler={UploadManagerImage}
                                                                                auto
                                                                                onSelect={(e) => {
                                                                                  setFileName(e.files[0].name);
                                                                                }}
                                                                              />
                                                                        
                                                                              {fileName && (
                                                                                <div className="mt-2">
                                                                                   {fileName}
                                                                                </div>
                                                                              )}
                                                                            </div>
                                                                        
                                                                          </div>
                                                                        </div>
                                        </div>
                                        <br></br>
                                        <Button label="Close" className="ml-2" severity="secondary" onClick={close} />
                                        <Button label="ADD" severity="info" onClick={addDataAsync} style={{ float: 'right', marginRight: "30px" }} />
                                    </Dialog>
                                    {/* <Dialog header="View" style={{ width: '50vw' }} visible={acceptfield} onHide={close}>
                                        <div className="modal-header">
                                            <Button icon="pi pi-times" className="p-button-text" />
                                        </div>
                                        <div className="modal-body">
                                            {view.map((response: any, index: number) =>
                                                <div key={index}>
                                                    {response.filetype === 'photo' && <img src={response.displayfile} alt="Doc" width="100%" height="auto" />}
                                                    {response.filetype !== 'photo' &&
                                                        <img src={response.displayfile} alt="Doc" width="100%" height="auto" />
                                                    }

                                                    {response.filetype === 'pdf' && (
                                                        <a href={response.displayfile} target="_blank" rel="noopener noreferrer">
                                                            Open PDF in New Tab
                                                        </a>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </Dialog> */}
   {/* <Dialog header="View" style={{ width: '50vw' }} visible={acceptfield} onHide={close}>
                                     <div className="modal-header">
                                         <Button icon="pi pi-times" className="p-button-text" />
                                     </div>
                                     <div className="modal-body">
                                         {view.map((response: any, index: number) =>
                                             <div key={index}>
                                                 {response.filetype === 'photo' && <img src={response.displayfile} alt="Doc" width="100%" height="auto" />}
                                                 {response.filetype !== 'photo' &&
                                                     <img src={response.displayfile} alt="Doc" width="100%" height="auto" />
                                                 }
                                                 {response.filetype === 'pdf' && (
                                                     <a href={response.displayfile} target="_blank" rel="noopener noreferrer">
                                                         Open PDF in New Tab
                                                     </a>
                                                 )}
                                             </div>
                                         )}
                                     </div>
                                 </Dialog> */}
                                        <Dialog header="View" style={{ width: '50vw' }} visible={acceptfield} onHide={close}>
                                                                      <div className="modal-header">
                                                                          <Button icon="pi pi-times" className="p-button-text" />
                                                                      </div>
                                                                      <div className="modal-body">
                                                                          {view.map((response: any, index: number) =>
                                                                              <div key={index}>
                                                                                  {response.filetype === 'photo' && <img src={response.displayfile} alt="Doc" width="100%" height="auto" />}
                                                                                  {response.filetype !== 'photo' &&
                                                                                      <img src={response.displayfile} alt="Doc" width="100%" height="auto" />
                                                                                  }
                                                                                  {response.filetype === 'pdf' && (
                                                                                      <a href={response.displayfile} target="_blank" rel="noopener noreferrer">
                                                                                          Open PDF in New Tab
                                                                                      </a>
                                                                                  )}
                                                                              </div>
                                                                          )}
                                                                      </div>
                                                                  </Dialog>
                                        {/*
                                         * Author: Anuradha ,Date: 2026-02-05 
                                         * Description: image view avvatam ledi s
                                         */}
                                        
                                                           

                                    <Dialog
                                        header="Verify Application"
                                        visible={verifyDilog}
                                        style={{ width: '32vw' }}
                                        onHide={() => setVerifyDilog(false)}
                                    >
                                        <div className="grid">
                                            {/* Hospital Name */}
                                            <div className="col-12 mb-1">
                                                <div className="grid align-items-center">
                                                    <div className="col-4">
                                                        <label htmlFor="hospitalName">Hospital Name:</label>
                                                    </div>
                                                    <div className="col-8">
                                                        <InputText
                                                            id="hospitalName"
                                                            style={{ width: '100%' }}
                                                            value={hospitalnames}
                                                            name="document"
                                                            placeholder="Enter Hospital"
                                                            disabled
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Doctor Name */}
                                            <div className="col-12 mb-1">
                                                <div className="grid align-items-center">
                                                    <div className="col-4">
                                                        <label htmlFor="doctorName">Doctor Name:</label>
                                                    </div>
                                                    <div className="col-8">
                                                        <InputText
                                                            id="doctorName"
                                                            style={{ width: '100%' }}
                                                            value={dname}
                                                            name="document"
                                                            placeholder="Enter Doctor Name"
                                                            disabled
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Estimate Amount */}
                                            <div className="col-12 mb-1">
                                                <div className="grid align-items-center">
                                                    <div className="col-4">
                                                        <label htmlFor="estimateAmount">Estimate Amount:</label>
                                                    </div>
                                                    <div className="col-8">
                                                        <InputText
                                                            id="estimateAmount"
                                                            style={{ width: '100%' }}
                                                            name="document"
                                                            placeholder="Enter Amount"
                                                            onChange={(e) => setEAmount(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            {/* Expiry Date */}
                                            <div className="col-12 mb-1">
                                                <div className="grid align-items-center">
                                                    <div className="col-4">
                                                        <label htmlFor="expiryDate">Expiry Date:</label>
                                                    </div>
                                                    <div className="col-8">
                                                        <InputText
                                                            id="expiryDate"
                                                            type="date"
                                                            style={{ width: '100%' }}
                                                            name="document"
                                                            placeholder="dd/mm/yyyy"
                                                            onChange={(e) => setDate(e.target.value)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <Button
                                            label="Close"
                                            onClick={() => setVerifyDilog(false)}
                                            style={{ float: 'left' }}
                                            severity="secondary"
                                        />
                                        <Button
                                            label="Verify"
                                            severity="info"
                                            onClick={VerifyApplication}
                                            style={{ float: 'right' }}
                                        />
                                    </Dialog>

                                    <Dialog header="Hold Application" visible={holddilog} style={{ width: '30vw', height: '40' }} onHide={() => setholddilog(false)} >
                                        <div className='row'>

                                            <div className='row'>
                                                <div className="grid pt-3">
                                                    <div className="col-3">
                                                        <label htmlFor="name"   >Reason For Hold:</label>
                                                    </div>
                                                    <div className="col md-3" >
                                                        <InputText id="name" style={{ width: '15vw' }} name="document" placeholder='Enter Reason' onChange={(e) => setHreason(e.target.value)} />
                                                    </div>
                                                    <div className="col-2" ></div>
                                                </div>
                                            </div>


                                        </div>
                                        <br></br>
                                        <Button label="Hold" severity="info" onClick={HoldApplication} style={{ float: 'right', marginRight: "30px" }} />
                                    </Dialog>
                                    <Dialog header="Reject Application" visible={reject} style={{ width: '30vw', height: '40' }} onHide={() => setReject(false)} >
                                        <div className='row'>

                                            <div className='row'>
                                                <div className="grid pt-3">
                                                    <div className="col-3">
                                                        <label htmlFor="name"   >Reason For Reject:</label>
                                                    </div>
                                                    <div className="col md-3" >
                                                        <InputText id="name" style={{ width: '15vw' }} name="document" placeholder='Enter Reason' onChange={(e) => setRreason(e.target.value)} />
                                                    </div>
                                                    <div className="col-2" ></div>
                                                </div>
                                            </div>


                                        </div>
                                        <br></br>
                                        <Button label="Reject" severity="info" onClick={RejectApplication} style={{ float: 'right', marginRight: "30px" }} />
                                    </Dialog>





                                </div>
                            </section>
                        </div>
                    </div>
                </div>
                <Toast ref={toast2} ></Toast>

            </div>
        </>
    )
}